module.exports = __webpack_public_path__ + "img/big_preview.55fd9c9c.png";